import { useEffect } from 'react';
import PropTypes from 'prop-types';

const MatomoTrackSearch = ({
  Search = undefined,
  SearchCategory = undefined,
  SearchHits = 0,
  SearchLocation = undefined,
  ExternalSearchHits = undefined,
}) => {
  useEffect(() => {
    if (window?._paq && Search && SearchCategory) {
      var searchKeyword = `${Search}`;

      if (ExternalSearchHits) {
        ExternalSearchHits?.map((tab) => {
          if (tab.SearchResult?.TotalHits === 0) {
            searchKeyword = `${SearchCategory};${Search}`;

            if (SearchLocation) {
              searchKeyword = `${SearchLocation};${SearchCategory};${Search}`;
            }
          }
          window?._paq.push([
            'trackSiteSearch',
            searchKeyword,
            (SearchCategory = tab.SearchApiIndex),
            (SearchHits = tab.SearchResult?.TotalHits || 0),
          ]);
        });
      } else {
        if (SearchHits === 0 && SearchCategory !== 'Globalt sök') {
          searchKeyword = `${SearchCategory};${Search}`;

          searchKeyword = `${
            SearchLocation || 'Plats'
          };${SearchCategory};${Search}`;
        }

        window?._paq.push([
          'trackSiteSearch',
          searchKeyword,
          SearchCategory,
          SearchHits,
        ]);
      }
    }
  }, []);

  return null;
};

MatomoTrackSearch.propTypes = {
  Search: PropTypes.string,
  SearchCategory: PropTypes.string,
  SearchHits: PropTypes.number,
};

export default MatomoTrackSearch;
